import logo from '../images/logo.svg';
import '../styles/header.css';

const Header = () => {
  return (
    <nav className="navigation flex justify-between items-center px-12 py-8" style={{ background: '#DBE6F2' }}>
      <div>
        <img src={logo} alt="logo" className="h-12 w-12 headerLogo" />
      </div>
      <div className="space-x-8">
        <a href="#templates" className="start">Get Started</a>
        <a href="#templates">Select Template</a>
      </div>
    </nav>
  )
}

export default Header;
